import { Keyboard } from '@ionic-native/keyboard';
import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, ToastController, IonicApp } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { Events } from 'ionic-angular';
import { AuthServiceProvider } from '../providers/auth-service/auth-service';
import { Network } from '@ionic-native/network';
import { Device } from '@ionic-native/device';
import { ENV } from '@app/env'
import { EnvService} from '../providers/env-friendly-service/env-friendly-service';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Utility } from '../providers/util-service/util-service';
import { AppConfigProvider } from '../providers/app-config-service/app-config.service';

require('dotenv').config()
@Component({
    templateUrl: 'app.html'
})
export class MyApp {

    @ViewChild(Nav) nav: Nav;

    userName: string = '';
    rootPage: string = (this.userName == undefined || this.userName == "") ? 'LoginPage' : 'HomePage';
    autoSync;
    isKiosk = false;
    pages: Array<{ title: string, component: any, icon: any, url?: any }>;
    networkUpdateToastActive = false;
    appStatus;
    materialsByCategory = this.utilities.category();
    platformCode;

    constructor(
        public platform: Platform,
        public statusBar: StatusBar,
        public splashScreen: SplashScreen,
        private authService: AuthServiceProvider,
        private screenOrientation: ScreenOrientation,
        public events: Events,
        public toastCtrl: ToastController,
        private network: Network,
        private toast: ToastController,
        private device: Device,
        private ionic: IonicApp,
        private keyboard: Keyboard,
        private iab: InAppBrowser,
        private envService: EnvService,
        private utilities: Utility,
        private appConfig: AppConfigProvider
    ) {
        console.log("Environment mode: ", ENV.mode);
        platform.ready().then(() => {
            if (this.platform.is('iphone')) {
                this.screenOrientation.lock('portrait');
            }
            // to track when app goes in background
            //Foreground
            this.platform.resume
                .subscribe((result) => {
                    console.log('::: App is now active');
                    this.appStatus = 'active';
                });
                //Background
                this.platform.pause
                .subscribe((result) => {
                    console.log('::: App is now in background');
                    this.appStatus = 'inactive';
            });
            this.splashScreen.hide();
            this.statusBar.overlaysWebView(false);
            this.statusBar.backgroundColorByHexString('#000000');
            this.statusBar.styleLightContent();

            //this.keyboard.hideKeyboardAccessoryBar(false);
            // leave this -- we do this for the 'slide the focused input up too high when opeing ios keyboard' issues
            //this.keyboard.disableScroll(true);

            this.keyboard.onKeyboardShow().subscribe(()=> {
                document.getElementById('body').classList.add('mobile-keyboard-open');
            });
            this.keyboard.onKeyboardHide().subscribe(()=> {
                document.getElementById('body').classList.remove('mobile-keyboard-open');
            });

            var lastTimeBackPress = 0;
            var timePeriodToExit = 2000;
            //check network disconnect
            this.network.onDisconnect().subscribe((data) => {
                if (this.appStatus !== 'inactive') {
                    this.displayNetworkUpdate(data.type);
                }
            }, error => console.log(error));
            //check network connect
            this.network.onConnect().subscribe((data) => {
                if (this.appStatus !== 'inactive') {
                    this.displayNetworkUpdate(data.type);
                }
                // this.syncServer();
            }, error => console.log(error));
            //Use back button - android,windows
            platform.registerBackButtonAction(() => {
                let view = this.nav.getActive();
                if (view.component.name == 'HomePage') {
                    if (new Date().getTime() - lastTimeBackPress < timePeriodToExit) {
                        this.platform.exitApp();
                    } else {
                        let toast = this.toastCtrl.create({
                            message: 'Press back again to exit.',
                            duration: 3000,
                            position: 'bottom'
                        });
                        toast.present();
                        lastTimeBackPress = new Date().getTime();
                    }
                } else {
                    //go to previous page
                    this.nav.pop();
                }
            });
            this.initializeApp();
        });

        events.subscribe('user:loggedIn', (userName) => {
            if (userName !== undefined && userName !== "") {
                this.userName = userName;
            }
            this.initializeApp()
        })

        events.subscribe('user:loggedOut', (anything) => {
            this.userName = undefined;
            this.nav.setRoot('LoginPage');
            this.closeOpenModals();
            const toast = this.toastCtrl.create({
                message: `Your session has ended.`,
                duration: 3000
            })
            toast.present();
        })

        // In case this is updated outside of the nav toggle...
        events.subscribe('material:categoryGrouping', (value) => {
            if (this.materialsByCategory !== value) {
                this.materialsByCategory = this.utilities.category();
            }
        })
    }

    initializeApp() {
        this.platform.ready().then(() => {
            // this.keyboard.hideFormAccessoryBar(false);
            this.materialsByCategory = this.utilities.category();
            // initialized menu
            var kiosk = window.localStorage.getItem('hl_kiosk');
            this.platformCode = this.device.platform;
            console.log('from app component', this.platformCode);
            if (kiosk) {
                if (typeof kiosk === 'string') {
                    kiosk = JSON.parse(kiosk);
                }
            }
            console.log('Is this a kiosk???', kiosk);
            this.pages = [];
            // used for an example of ngFor and navigation
            console.log('app component build pages, but first check device');
            if (this.platformCode && this.platformCode !== 'browser') {
                console.log('adding scan menu item');
                this.pages.push({ title: 'Scan', component: 'ScannerPage', icon: 'fa-camera' });
            } else {
                console.log('skipping scan menu item because device platform says: ', this.device.platform);
                this.pages.push({ title: 'Find Sample', component: 'HomePage', icon: 'fa-keyboard-o' });
            }
            // can only create if not in kiosk mode
            if (!kiosk) {
                this.pages.push({ title: 'Create Sample', component: 'SamplePage', icon: 'fa-qrcode' });
            } else {
                this.isKiosk = true;
            }

            var academyUrl = this.envService.getAppUrl('materials', 'assets', '/templates/documentation/Materials/#/');

            this.pages.push({ title: 'Samples', component: 'ListPage', icon: 'fa-list' });
            this.pages.push({ title: 'Forms', component: 'FormsPage', icon: 'fa-file-text-o' });
            // Dashboards come from the configuration service, so one can be swapped without a
            // build. The defaults are the two entries that used to be written here.
            const tmpDashboardsAt = this.pages.length;
            this.pages.push({ title: 'Academy', component: null, icon: 'fa-graduation-cap', url: academyUrl });
            this.pages.push({ title: 'About', component: 'AboutPage', icon: 'fa-info-circle' });
            this.userName = window.localStorage.getItem('userName');
            this.placeDashboardPages(tmpDashboardsAt);
            this.appConfig.load().then(() => { this.placeDashboardPages(tmpDashboardsAt); });
        });
    }

    /**
     * Put the configured dashboards into the menu at the given position, replacing any already
     * there. Run once with whatever configuration is in hand so the menu is never without them,
     * and again when the server's answer arrives.
     *
     * @param {number} pAt Index in `pages` the dashboard entries occupy.
     * @return {void}
     */
    placeDashboardPages(pAt: number) {
        const tmpEntries = this.appConfig.getDashboards().map((pRoute) => ({
            title: pRoute.Name, component: 'DashboardPage', icon: pRoute.Icon, dashboard: pRoute
        }));
        const tmpExisting = this.pages.filter((pPage) => pPage.component === 'DashboardPage').length;
        this.pages.splice(pAt, tmpExisting, ...tmpEntries);
    }

    openPage(page) {
        var currentPage = this.nav.getActive();
        console.log('Current Page:', currentPage);
        // if we are going to an external url instead of another app view
        if (page.component === null && page.hasOwnProperty('url')) {
            // Adding cache bust so iOS apps load the latest content.
            let cacheBustURL = `${page.url}?lightingbug=${ENV.GIT_SHA.substr(0,9)}`
            const isMobileDevice = (this.device.platform && this.device.platform !== 'browser' && this.device.platform !== null);
            let target = '_system';
            if (isMobileDevice)
            {
                target = '_blank';
            }
            this.iab.create(cacheBustURL, target, 'location=no');
            return;
        }
        // another app view
        if (page.component === 'SamplePage') {
            // Numeric compare. The deep link supplies IDSample as a string ('sample/:IDSample'),
            // every in-app push supplies a number, and `0 !== '0'` is true - so the guard meant to
            // stop a second create page from stacking never fired for a page reached in-app.
            if (Number(currentPage.data && currentPage.data.IDSample) !== 0) {
                window.localStorage.setItem('samplePageType', 'edit');
                this.nav.push(page.component, {
                    IDSample: 0,
                    isEdit: true
                });
            }
        }
        else if (currentPage.component.name !== page.component) {
            if (page.title == 'Home') {
                this.nav.setRoot('HomePage');
                this.nav.popToRoot();
            }
            else if (page.component === 'DashboardPage'){
                this.nav.push(page.component, { dashboard: page.dashboard });
            }
            else{
                this.nav.push(page.component);
            }
        }
        else if(page.component === 'DashboardPage'){
            // Same page, different dashboard. Carried as a nav param rather than through local
            // storage, which two tabs would race on.
            this.nav.push(page.component, { dashboard: page.dashboard });
        }
    }

    goToOnboarding() {
        // temp restart onboarding
            this.nav.setRoot('OnboardPage');
            this.nav.popToRoot();
    }

    // in case any open modals are still around
    closeOpenModals() {
        let activeModal = this.ionic._modalPortal.getActive();
        if(activeModal) {
            activeModal.dismiss();
            return;
        }
    }

    displayNetworkUpdate(connectionState: string) {
        console.log('displayNetworkUpdate', connectionState, this.authService.checkSession());
        if (!this.networkUpdateToastActive) {
            // set the flag
            this.networkUpdateToastActive = true;
            // make some toast
            this.toast.create({
                message: `You are now ${connectionState}.`,
                duration: 3000
            }).present();
            // delay the flag changing back
            setTimeout(()=>{
                this.networkUpdateToastActive = false;
            }, 3000)
        }
    }

    onCategory(toggleStatus){
        console.log('Materials by Category:', toggleStatus.checked);
        this.materialsByCategory = toggleStatus.checked;
        this.utilities.category(this.materialsByCategory);
    }

    public async logout() {
        window.localStorage.removeItem(this.userName);
        window.localStorage.removeItem('session');
        window.localStorage.removeItem('sessionData');
        window.localStorage.removeItem('userRoleIndex');
        window.localStorage.removeItem('userID');
        window.localStorage.removeItem('customerID');
        window.localStorage.removeItem('userName');
        window.localStorage.removeItem('afterlogin');
        window.localStorage.removeItem('GUIDExternal');
        window.localStorage.removeItem('IDUser');
        window.localStorage.removeItem('GUIDUser');
        console.log('logout called');
        this.userName = '';
        this.authService.logout();
        this.closeOpenModals();
        this.nav.setRoot('LoginPage');
    }

    // temp reset of onboarding
    clearCookies() {
        delete window.localStorage['onboarded'];
        this.nav.push('HomePage');
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts